module.exports = __webpack_public_path__ + "img/login.50208979.png";